export const BaseUrl = "https://system-stg.kwick-box.com/api/";
export const AmsBaseUrl = "https://ams-stg.kwick-box.com/api/";
export const GoogleMapsApiKey = 'AIzaSyBVpqgwvUDtznbA74DbRjM4t3tQhqQkZ8g';
